const common = {
  search: 'חיפוש...',
  select: 'בחר',
  selectDropdown: 'בחר...',
  loading: 'טוען...',
  selected: '{{count}} נבחר ',
  noOptions: 'אין אפשרויות בחירה',
  all: 'הכל',
  allWithName: 'הכל {{name}}',
  add: 'הוסף',
  selectAll: 'בחר הכל',
  unselectAll: 'בטל בחירה של הכל',
  enter: 'הצג',
  items: '{{count}} פריטים, ',
  shortWeekdays: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
  distanceType: {
    metric: 'ק"מ',
    imperial: 'מייל',
  },
  hour: 'שעה',
  reductions: {
    h: 'ש',
    m: 'ד',
    s: 'ש',
  },
  connectorStatus: {
    free: 'זמין',
    busy: 'לא זמין',
    unknown: 'לא ידוע',
    error: 'שבור',
  },
  yes: 'כן',
  no: 'לא',
  weekDays: {
    sunday: 'ראשון',
    monday: 'שני',
    tuesday: 'שלישי',
    wednesday: 'רביעי',
    thursday: 'חמישי',
    friday: 'שישי',
    saturday: 'שבת',
  },
  internal: 'מיקום פנימי',
  google: 'גוגל',
  operationAddress: {
    student: 'כתובת התלמיד',
    employee: 'כתובת העובד',
  },
  map: {
    zoomIn: 'זום פנימה',
    zoomOut: 'זום החוצה',
    fullScreen: 'מסך מלא',
    polygon: {
      exceededModal: {
        body: 'היקף אזור "בלוק" אינו יכול לעלות על 10 ק"מ',
        cancel: 'ביטול',
      },
      deleteModal: {
        header: 'מחיקת פוליגון?',
        body: 'אתה עומד למחוק את הפוליגון',
      },
    },
  },
  roles: {
    dispatchadmin: 'מנהל משלוחים',
    dispatcher: 'משלח',
    superagent: 'סוכן על',
    agent: 'סוכן',
    supplier: 'ספק',
    superadmin: 'מנהל מערכת על',
    accountingadmin: 'מנהל חשבונות',
    accountant: 'רואה חשבון',
    companyadmin: 'מנהל חברה',
    admin: 'מנהל',
  },
  duration: 'משך',
  distance: 'מרחק',
};

export default common;
